shvenergy.productOverview = (function ($) {
	"use strict";
	var cdnvalue = $("#cdnInput").data("value");
	const $productListTagsCont = $('#product-overview-tags');
	const $productListCont = $('.js-product-list-container');
	let $allInputs;

	if ($productListTagsCont.length <= 0) {
		return;
	}

	function setUpEventListeners() {


		// Handle click tag toggle  (on mobile)
		document.getElementById('tag-toggle').addEventListener('click', () => {
			//scrollToArticleList();
			toggleTagsContainer();
		});

		// Handle clicking tag back button (on mobile)
		document.getElementById('tag-back').addEventListener('click', toggleTagsContainer);

	}

	function toggleTagsContainer() {
		var tagNavContainer = document.querySelector('.news-list-tags');
		if (tagNavContainer.classList.contains('is-active')) {
			return tagNavContainer.classList.remove('is-active');
		}
		return tagNavContainer.classList.add('is-active');
	}

	function onInputChange() {

		let usageAreas = [];
		let products = [];

		$.each($allInputs, function (i, inp) {

			let $inp = $(inp);

			if ($inp.prop('checked')) {
				if ($inp.data('product-category-type') === 'usageareas') {
					usageAreas.push($inp.data('guid'));
				}
				else if ($inp.data('product-category-type') === 'gastypes') {
					products.push($inp.data('guid'));
				}
			}
		});
		cookieLogic(usageAreas, products);
	}

	function cookieLogic(usageAreas, products) {
		let data;

		if (shvenergy.cookies.hasCookieCategoryConsent('_shvenergy_product_overview')) {
			if (shvenergy.cookies.getCookie('_shvenergy_product_overview')) {
				let currentCookie = shvenergy.cookies.getCookie('_shvenergy_product_overview');
				data = JSON.parse(currentCookie);

				data.GasTypes = products;
				data.UsageAreas = usageAreas;
			}
		} else {
			data = {
				GasTypes: products,
				UsageAreas: usageAreas
			};
		}

		let str = JSON.stringify(data);

		if (shvenergy.cookies.hasCookieCategoryConsent('_shvenergy_product_overview')) {
			shvenergy.cookies.setCookie('_shvenergy_product_overview', str, (1 / (24 * 6)));
		}
		callApi(str);
	}

	function callApi(str) {
		$.post({
			url: "/api/products/getproductsbycategories",
			data: str,
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
			}
		}).done(function (response) {
			renderProductList(response);
		});
	}

	function renderProductList(response) {
		const container = $productListCont.find('.product-overview__articles-grid');
		const headlineTag = container.data('h-tag-as') || 'h3';
		container.html('');

		let products = response.Products;
		let settings = response.Settings;
		let target = settings.DirectlyLinkToProductCta ? "_blank" : "";
		let elms = "";

		//$productListCont.find('.product-overview__articles-grid').append('<div class="gap"></div><div class="gap"></div><div class="gap"></div>')

		const items = products.map((product, index) => {
			const rootItem = $('<a>', {
				href: product.ProductUrl,
				target,
				class: 'related-article animateIn',
				css: {
					opacity: 0,
					animationDelay: `${index * 150}ms`
				}
			});

			if (product.ProductImageProtectAssetUrl.length) {
				rootItem.append(
					$('<div>', {
						'aria-hidden': true,
						class: 'related-article__image',
						css: {
							paddingBottom: '100%'
						},
						html: $('<img>', {
							src: product.ProductImageProtectAssetUrl,
							width: 375,
							height: 375,
							'data-lazyload': '',
							class: 'lazyloaded',
							alt: product.ProductImage.Alt,
						})
					})
				)
			}

			const content = $('<div>', {
				class: 'related-article__content',
			});

			const productTitle = $(`<${headlineTag}>`, {
				class: 'product-header h3',
			});

			if (settings.ShowProductNameTag) {
				productTitle.append(
					$('<span>', {
						class: 'related-article__content__new',
						html: product.ProductNameTagText
					})
				);
			};

			productTitle.append(product.ProductName);

			if (product.GasTypeName) {
				productTitle.append(
					$('<span>', {
						class: 'product-subheader',
						html: product.GasTypeName,
					})
				);
			};

			content.append(productTitle);

			if (settings.ShowProductPrices) {
				const products = [product.Price1, product.Price2].filter(item => !!item);
				content.append(
					$('<p>', {
						text: products.join(' '),
					})
				);
			}

			if (settings.ShowProductPriceTag) {
				content.append(
					$('<p>', {
						class: 'related-article__content__discount',
						html: product.PriceTagText,
					})
				);
			}

			if (settings.ShowExternalLinkIcon) {
				content.append(
					$('<svg>', {
						focusable: false,
						'aria-hidden': true,
						width: 16,
						height: 16,
						viewBox: '0 0 16 16',
						html: '<use xlink:href="' + cdnvalue + '/dist/svgsprite/icons.svg#New-window_16x16"></use>'
					})
				);
			}
			rootItem.append(content);
			return rootItem;
		});

		container.empty().append(
			...items,
			...Array.from({ length: 3 }).map(() => $('<div>', { class: 'gap' })),
		)
	}

	$(function () {
		setUpEventListeners();

		$allInputs = $productListTagsCont.find('input');

		$.each($allInputs, function (i, inp) {
			$(inp).on("click", function () {
				var el = $(this);
				var trackingText = el.attr("id");
				var trackingAction = "Category clicked ";
				if (el.prop('checked')) {
					trackingAction += "(selected)";
				} else {
					trackingAction += "(unselected)";
				}

				shvenergy.tracking.trackEvent("Product overview", trackingAction, trackingText);
				onInputChange();
			});
		});
	});
})(jQuery);